import React from 'react'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'
import { graphql, StaticQuery } from 'gatsby'

const SEO = ({ url }) => {
  return (
    <StaticQuery
      query={query}
      render={({
                 campaignData: {
                   metaTitle,
                   description,
                   coverImage,
                 },
                 site: {
                   siteMetadata: {
                     defaultTitle,
                     defaultDescription,
                   },
                 },
               }) => {

        const seo = {
          title: metaTitle || defaultTitle,
          description: description || defaultDescription,
          image: coverImage,
          url: url || '/',
        }

        return (
          <Helmet title={seo.title}>
            <meta name="generator" content="Perspective Funnels"/>

            {seo.title && <meta property="title" content={seo.title}/>}
            <meta name="description" content={seo.description}/>
            <meta name="image" content={seo.image}/>
            {seo.url && <meta property="og:url" content={seo.url}/>}
            {seo.title && <meta property="og:title" content={seo.title}/>}
            {seo.description && (
              <meta property="og:description"
                    content={seo.description}/>
            )}
            {seo.image && <meta property="og:image" content={seo.image}/>}
            <meta name="twitter:card" content="summary_large_image"/>
            {seo.title &&
            <meta name="twitter:title" content={seo.title}/>}
            {seo.description && (
              <meta name="twitter:description"
                    content={seo.description}/>
            )}
            {seo.image &&
            <meta name="twitter:image" content={seo.image}/>}
          </Helmet>
        )
      }}
    />
  )
}

export default SEO

SEO.propTypes = {
  url: PropTypes.string,
}

const query = graphql`
    query SEO {
        site {
            siteMetadata {
                defaultTitle: title
                defaultDescription: description
            }
        }
        campaignData {
            _id
            metaTitle
            description
            coverImage
            pages {
                _id
                isResult
            }
        }
    }
`
